import { initDocument } from "@src/config/init";
import { createTxWidgetWC } from "./TxWidgetWC";
import { TxWidgetWCWrapped } from "./TxWidgetWCWrapped";
import * as Sentry from "@sentry/react";

const TxWidgetWC = createTxWidgetWC();

Sentry.init({
  dsn: "https://d0486453fb6a9c76fcb810bcc35272f1@o4509169066967045.ingest.de.sentry.io/4509169071489104",
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

initDocument();

export * from "@src/models";
export { TxWidgetWCWrapped as TxWidget } from "./TxWidgetWCWrapped";
export { TxWidgetWC };

const SwapperSDK = {
  TxWidget: TxWidgetWCWrapped,
  TxWidgetWC,
};

export default SwapperSDK;
